import React from 'react';
import CaseRendererProps from './infrastructure/caseRendererProps';

const CaseRenderer = <T extends string | number>(props: CaseRendererProps<T>) =>
  (props.caseBy[props.value] ?? props.defaultComponent ?? null) as React.ReactElement;

export default CaseRenderer;
